// 레이드 4인 넷 모드 공개 스위치(docs/RAID-PRD.md 0장 2단계). 운영 공개는 이 released 값 하나로만 바뀐다.
// 미리보기: 운영 호스트가 아닌 곳(개발 서버·로컬·workers.dev 진단)에서는 ?raidnet=1 쿼리로 연다(social.ts 파티·거래소와 같은 규칙).
// 서버 스위치(wrangler vars RAID_NET)가 꺼져 있으면 클라가 열려도 /api/raid/ws가 열리지 않아 연결이 안 된다.
import { previewQueryAllowedHere } from '../previewFlags';

export const RAID_NET_RELEASE = { released: false } as const;

/** 쿼리 읽기(브라우저 밖·실패면 빈 값) */
function query(name: string): string | null {
  try { return typeof location === 'undefined' ? null : new URLSearchParams(location.search).get(name); } catch { return null; }
}

/** 레이드 「같이 출정(4인)」을 보여도 되는가 */
export function raidNetEnabledHere(): boolean {
  return RAID_NET_RELEASE.released || (query('raidnet') === '1' && previewQueryAllowedHere());
}
/** QA: 레이드 서버 주소 덮어쓰기(?raidws=ws://…) — 운영 호스트에서는 무시 */
export function raidWsOverride(): string | undefined {
  const v = query('raidws');
  return v && previewQueryAllowedHere() && /^wss?:\/\/[^\s]+$/.test(v) ? v : undefined;
}
